import React from "react";
import Banner from "../components/Banner";
import Form from "../components/Form";
import MatchCalendar from "../components/MatchCalendar";
import PrayerLibrary from "../components/PrayerLibrary";
import Contact from "../components/Contact";
import Particles from "../components/Particles";
import { FirestoreProvider } from "../contexts/FirestoreContext";

const Home: React.FC = () => {
  return (
    <FirestoreProvider>
    <div className="relative min-h-screen">
      {/* Fixed video background for all sections */}
      <video
        className="fixed inset-0 z-0 h-full w-full object-cover"
        src="https://t1-pray.pages.dev/bg.mp4"
        poster="/bg-poster.jpg"
        autoPlay
        loop
        muted
        playsInline
      />
      <div
        className="fixed inset-0 z-0"
        style={{
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.15) 30%, rgba(0,0,0,0.5) 60%, rgba(0,0,0,0.85) 100%)",
        }}
      />

      <Particles />

      {/* Scrollable content */}
      <div className="snap-container relative z-10">
        {/* Section 1: Hero */}
        <section className="snap-section relative" style={{ padding: 0 }}>
          <div className="absolute inset-0 flex flex-col items-center justify-start pt-[30%] md:pt-[8%]">
            <Banner />
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-0 right-0 scroll-indicator flex flex-col items-center gap-2">
            <span className="text-white/40 text-xs font-body tracking-widest uppercase">
              Kéo xuống để khấn
            </span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-white/30"
            >
              <polyline points="6,9 12,15 18,9" />
            </svg>
          </div>
        </section>

        {/* Section 2: Calendar + Form */}
        <section className="snap-section relative" style={{ padding: 0 }}>
          <div className="absolute inset-0 flex flex-col items-center pt-[5%]">
            <div className="flex flex-col items-center text-center px-4 pt-4 pb-2">
              <div className="w-16 h-1 bg-primary rounded-full mb-4" />
              <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter leading-none mb-3">
                <span className="text-primary drop-shadow-[0_0_40px_rgba(220,38,38,0.6)]">
                  CẦU NGUYỆN
                </span>
                <span className="text-white drop-shadow-[0_0_20px_rgba(255,255,255,0.2)]">
                  {" "}CHO T1
                </span>
              </h2>
              <div className="w-16 h-1 bg-primary rounded-full mt-4" />
            </div>
            <div className="w-full max-w-5xl mx-auto px-4 mt-6 flex-1 overflow-y-auto">
              <div className="flex flex-col lg:flex-row gap-6 items-stretch justify-center">
                <div className="w-full lg:w-5/12">
                  <MatchCalendar />
                </div>
                <div className="w-full lg:w-7/12">
                  <Form />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3: Prayer Library + Footer */}
        <section className="snap-section relative" style={{ padding: 0 }}>
          <div className="absolute inset-0 flex flex-col items-center pt-[5%]">
            <PrayerLibrary />
            <div className="w-full py-6 mt-auto flex justify-center border-t border-white/[0.04]">
              <Contact />
            </div>
          </div>
        </section>
      </div>
    </div>
    </FirestoreProvider>
  );
};

export default Home;
